import { getFile, postFile, putFile, destroyFile } from './base.js';
import { FILE_PREFIX } from '../utilities';

export const Files = {
  listAll: (submissionId) =>
    getFile(`${FILE_PREFIX}/current-applicant/forms/${submissionId}/files`).then(
      ({ data }) => data
    ),
  get: (submissionId, id) =>
    getFile(`${FILE_PREFIX}/current-applicant/forms/${submissionId}/files/${id}`).then(
      ({ data }) => data
    ),
  upload: (submissionId, documentType, formData, onUploadProgress) =>
    postFile(`${FILE_PREFIX}/current-applicant/forms/${submissionId}/files/document-type/${documentType}`, formData, {
      onUploadProgress,
    }).then(({ data }) => data),
  download: (submissionId, id, filename) =>
    putFile(
      `${FILE_PREFIX}/current-applicant/forms/${submissionId}/files/${id}/${encodeURIComponent(
        filename
      )}`
    ).then(({ data }) => data),
  destroy: (submissionId, id) =>
    destroyFile(`${FILE_PREFIX}/current-applicant/forms/${submissionId}/files/${id}`).then(
      ({ data }) => data
    ),
};
